import { render } from "./TenantGeneral.vue?vue&type=template&id=0be8fef7&scoped=true&ts=true"
import script from "./TenantGeneral.vue?vue&type=script&lang=ts"
export * from "./TenantGeneral.vue?vue&type=script&lang=ts"

import "./TenantGeneral.vue?vue&type=style&index=0&id=0be8fef7&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be8fef7"]])

export default __exports__